import DrawModeBase from '@/lib/mapbox/draw-mode-base'
/**
 * Edit mode for markups whose geometry should not be editable on the map
 */
class StaticEditMode extends DrawModeBase {
  /**
   * @inheritDoc
   */
  toDisplayFeatures(geoJson) {
    return [geoJson]
  }
}

export default StaticEditMode
